export default {
  name: 'AppFooter',
  data() {
    return {
      menuItem: null,
      footerOpen: false,
      loginMenuOpen: false,
    }
  },
  methods: {
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    openItem(id) {
      this.menuItem = id
    },
    closeItem() {
      this.menuItem = null
    },
  },
}
